import React from 'react';

type ButtonProps = {
  label: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
};

export default function Button({ label, onClick, variant = 'primary', disabled = false, type = 'button', className = '' }: ButtonProps) {
  const base = 'px-4 py-2 rounded-lg font-medium transition';
  const styles = variant === 'primary'
    ? 'bg-primary text-white hover:bg-primaryDark'
    : 'bg-accent text-black hover:bg-accentLight';
  
  const disabledStyles = disabled 
    ? 'opacity-50 cursor-not-allowed' 
    : '';

  return (
    <button 
      type={type}
      className={`${base} ${styles} ${disabledStyles} font-tajawal ${className}`} 
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
} 